import { IdOutskirtBuildings } from "./IdOutskirtBuildings";
export var mapOutskirtTooltipOffset = new Map([
    [IdOutskirtBuildings.Watertower, new PIXI.Point(15, -170)],
    [IdOutskirtBuildings.TournamentTent, new PIXI.Point(0, -150)],
    [IdOutskirtBuildings.Cafe, new PIXI.Point(0, -110)],
    [IdOutskirtBuildings.Doghouse, new PIXI.Point(0, -80)],
    [IdOutskirtBuildings.ExternalBarn, new PIXI.Point(0, -110)],
    [IdOutskirtBuildings.Harbor, new PIXI.Point(-30, -200)],
    [IdOutskirtBuildings.Library, new PIXI.Point(100, -400)],
    [IdOutskirtBuildings.Market, new PIXI.Point(100, -200)],
    [IdOutskirtBuildings.Nursery, new PIXI.Point(0, -90)],
    [IdOutskirtBuildings.Pier, new PIXI.Point(0, -80)],
    [IdOutskirtBuildings.ThemedEvent, new PIXI.Point(0, -110)],
]);



//////////////////
// WEBPACK FOOTER
// ./src/constants/mapOutskirtTooltipOffset.ts
// module id = 2158
// module chunks = 3